import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  FiBarChart,
  FiPieChart,
  FiMonitor,
  FiBarChart2,
  FiHexagon,
} from 'react-icons/fi'

import { DrawerItem } from 'src/components'

import useCheckIfSelected from './useCheckIfSelected'
import { Container, Group, GroupLabel } from './styles'

const MainDrawerItems: React.FC = () => {
  const { t } = useTranslation('Main')
  const handleCheckIfSelected = useCheckIfSelected()

  return (
    <Container>
      <Group>
        <GroupLabel>{t('labels.general')}</GroupLabel>

        <DrawerItem
          to="/"
          text={t('drawer.dashboard')}
          iconComponent={<FiPieChart />}
          selected={handleCheckIfSelected('/', true)}
        />

        <DrawerItem
          to="/automatic-dashboard"
          text={t('drawer.automaticDashboard')}
          iconComponent={<FiBarChart />}
          selected={handleCheckIfSelected('/automatic-dashboard')}
        />
      </Group>

      <Group>
        <GroupLabel>{t('labels.configs')}</GroupLabel>

        <DrawerItem
          to="/create-dashboard-type"
          text={t('drawer.createDashboardType')}
          iconComponent={<FiHexagon />}
          selected={handleCheckIfSelected('/create-dashboard-type')}
        />

        <DrawerItem
          to="/create-analysis"
          text={t('drawer.createAnalysis')}
          iconComponent={<FiBarChart2 />}
          selected={handleCheckIfSelected('/create-analysis')}
        />

        <DrawerItem
          to="/create-dashboard-screen"
          text={t('drawer.createDashboardScreen')}
          iconComponent={<FiMonitor />}
          selected={handleCheckIfSelected('/create-dashboard-screen')}
        />
      </Group>
    </Container>
  )
}

export default MainDrawerItems
